module.exports = __webpack_public_path__ + "static/img/device-fetal.1d028ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device-fetal.png
// module id = 36JV
// module chunks = 1